(() => {
  const relocatePreorderWidget = () => {
    document.querySelectorAll('#remind-preorder-container').forEach((container) => {
      const paymentButton = container.closest('.shopify-payment-button, [data-shopify="payment-button"]');

      if (!paymentButton) {
        return;
      }

      const buyButtons = paymentButton.closest('buy-buttons');

      if (!buyButtons || paymentButton.parentElement !== buyButtons) {
        return;
      }

      buyButtons.insertBefore(container, paymentButton);
    });
  };

  const observer = new MutationObserver(relocatePreorderWidget);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('DOMContentLoaded', relocatePreorderWidget, { once: true });
  relocatePreorderWidget();
})();
